import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const PriorityIcon = ({size, color, onClick, intl, shouldShow}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '11';
			case SIZE.STANDARD:
				return '13';
			default:
				return '14';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '16';
			default:
				return '16';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan
			onClick={handleClick}
			width={getWidth(size)}
			height={getHeight(size)}
			title={intl.formatMessage({id: 'common.high_priority'})}
			shouldShow={shouldShow}
		>
			<svg width={getWidth(size)} height={getHeight(size)} xmlns="http://www.w3.org/2000/svg">
				<path d="M0 0v16h1.647V9.6H14V0z" fill={color} fillRule="evenodd" />
			</svg>
		</StyledSpan>
	);
};

PriorityIcon.SIZE = SIZE;
PriorityIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	shouldShow: PropTypes.bool,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	intl: PropTypes.shape({
		formatMessage: PropTypes.func,
	}),
};

PriorityIcon.defaultProps = {
	color: CSS_CONSTANTS.v2_border_invalid,
	intl: {
		formatMessage: ({id}) => id,
	},
};

export const StyledSpan = Styled.span`
	display: ${props => (props.shouldShow ? 'inline' : 'none')}; // Dirty hack for google translate
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	svg {
		vertical-align:text-top;
	}
`;
